<template>
    <div v-if="showError && buefy === false" class="alert alert-warning error" :class="{fixed: inline !== true}" role="alert">
        <span v-if="message">{{message}}</span>
        <span v-else-if="currentError !== null">{{currentError.typeLabel}} - {{currentError.message}}</span>
        <template v-if="isFlightPlan">
            <div @click="dismiss" class="alert-close">
                <fa icon="xmark"></fa>
            </div>
        </template>
        <template v-else>
            <button type="button" class="close" @click="dismiss">
                <span>&times;</span>
            </button>
        </template>
    </div>
</template>

<script>
  export default {
    name: "error",
    props: {
      message: {
        type: String,
        default: null
      },
      inline: {
        type: Boolean,
        default: false
      },
      buefy: false
    },
    computed: {
      showError() {
        return this.message !== null || this.currentError !== null;
      },
      id() {
        return _.uniqueId();
      },
      currentError() {
        return this.$store.state.error.currentError;
      },
      state: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue);
        }
      },
      isFlightPlan() {
          return window.location.pathname === '/beta.html';
      },
    },
    watch: {
      showError(){
        if(this.showError){
          this.$buefy.toast.open({
            duration: 5000,
            pauseOnHover: true,
            message: this.message || `${this.currentError.typeLabel} - ${this.currentError.message}`,
            type: 'is-danger'
          });
        }
      }
    },
    methods: {
      dismiss() {
        if (this.message !== null) {
          this.$emit('dismiss');
        } else {
          this.$store.dispatch('error/clear');
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
    @include error();
</style>